var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup_detail_wrap"},[_c('div',{staticClass:"popup_detail"},[_c('page-header',{staticClass:"not_main"}),_c('div',{staticClass:"popup_detail_content"},[_c('div',{staticClass:"popup_detail_content_box"},[_c('popup-detail-component',{attrs:{"popupKey":_vm.popupKey}})],1)]),_c('page-footer',{staticClass:"not_main"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }